module.exports = __webpack_public_path__ + "media/C8.752206f4.wav";